"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * New Api\'s for all actions
 * Actions APIs
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: ggrigorian@tivo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionKernelType = void 0;
/**
 * Type of actionKernel
 * @export
 * @enum {string}
 */
exports.ActionKernelType = {
    ActionKernel: 'actionKernel',
    WatchLiveActionKernel: 'watchLiveActionKernel',
    WatchFromMyShowsActionKernel: 'watchFromMyShowsActionKernel',
    ResumeFromMyShowsActionKernel: 'resumeFromMyShowsActionKernel',
    WatchFromSocuActionKernel: 'watchFromSocuActionKernel',
    WatchFromVodActionKernel: 'watchFromVodActionKernel',
    WatchFromVodOfferActionKernel: 'watchFromVodOfferActionKernel',
    WatchVodOfferPreviewActionKernel: 'watchVodOfferPreviewActionKernel',
    WatchVodContentPreviewActionKernel: 'WatchVodContentPreviewActionKernel',
    WatchFromOttActionKernel: 'watchFromOttActionKernel',
    StreamingOptionsActionKernel: 'streamingOptionsActionKernel',
    CreateOnePassActionKernel: 'createOnePassActionKernel',
    CreateOnePassActionKernelV2: 'createOnePassActionKernelV2',
    ModifyOnePassActionKernel: 'modifyOnePassActionKernel',
    ModifyOnePassActionKernelV2: 'modifyOnePassActionKernelV2',
    BookmarkThisShowActionKernel: 'bookmarkThisShowActionKernel',
    BookmarkThisMovieActionKernel: 'bookmarkThisMovieActionKernel',
    BookmarkThisEpisodeActionKernel: 'bookmarkThisEpisodeActionKernel',
    AddSeasonStreamingVideoActionKernel: 'addSeasonStreamingVideoActionKernel',
    AddYearStreamingVideoActionKernel: 'addYearStreamingVideoActionKernel',
    DeleteBookmarkActionKernel: 'deleteBookmarkActionKernel',
    RecordAgainActionKernel: 'recordAgainActionKernel',
    RecordThisShowActionKernel: 'recordThisShowActionKernel',
    RecordThisMovieActionKernel: 'recordThisMovieActionKernel',
    RecordThisEpisodeActionKernel: 'recordThisEpisodeActionKernel',
    ModifyRecordingActionKernel: 'modifyRecordingActionKernel',
    RecoverRecordingActionKernel: 'recoverRecordingActionKernel',
    StopAndDeleteRecordingActionKernel: 'stopAndDeleteRecordingActionKernel',
    DeleteRecordingActionKernel: 'deleteRecordingActionKernel',
    CancelRecordingActionKernel: 'cancelRecordingActionKernel',
    CancelOnePassActionKernel: 'cancelOnePassActionKernel',
    CancelOnePassActionKernelV2: 'cancelOnePassActionKernelV2',
    RentThisShowActionKernel: 'rentThisShowActionKernel',
    RentAndWatchNowActionKernel: 'rentAndWatchNowActionKernel',
    RentCallAheadActionKernel: 'rentCallAheadActionKernel',
    RentAndWatchCallAheadActionKernel: 'rentAndWatchCallAheadActionKernel',
    RentOptionsUnavailableActionKernel: 'rentOptionsUnavailableActionKernel',
    SubscribeToSocuActionKernel: 'subscribeToSocuActionKernel',
    SubscribeToNdvrActionKernel: 'subscribeToNdvrActionKernel',
    InfoOfferActionKernel: 'infoOfferActionKernel',
    InfoContentActionKernel: 'infoContentActionKernel',
    InfoRecordingActionKernel: 'infoRecordingActionKernel',
    ModifyKeepUntilActionKernel: 'modifyKeepUntilActionKernel',
    CreateMultiOnePassActionKernel: 'createMultiOnePassActionKernel',
    ModifyMultiOnePassActionKernel: 'modifyMultiOnePassActionKernel',
    CancelMultiOnePassActionKernel: 'cancelMultiOnePassActionKernel',
    BookmarkThisGameActionKernel: 'bookmarkThisGameActionKernel',
    BookmarkThisMatchActionKernel: 'bookmarkThisMatchActionKernel',
    BookmarkThisRaceActionKernel: 'bookmarkThisRaceActionKernel',
    BookmarkThisEventActionKernel: 'bookmarkThisEventActionKernel',
    RecordThisGameActionKernel: 'recordThisGameActionKernel',
    RecordThisMatchActionKernel: 'recordThisMatchActionKernel',
    RecordThisRaceActionKernel: 'recordThisRaceActionKernel',
    RecordThisEventActionKernel: 'recordThisEventActionKernel',
    MoreInfoContentActionKernel: 'moreInfoContentActionKernel',
    MoreInfoUnifiedCollectionActionKernel: 'moreInfoUnifiedCollectionActionKernel'
};
